function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-school"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8337 7.49996L10.5003 4.16663L2.16699 7.49996L10.5003 10.8333L18.8337 7.49996ZM18.8337 7.49996V12.5M5.50033 8.83337V13.3334C5.50033 13.9964 6.02711 14.6323 6.96479 15.1011C7.90247 15.57 9.17424 15.8334 10.5003 15.8334C11.8264 15.8334 13.0982 15.57 14.0359 15.1011C14.9735 14.6323 15.5003 13.9964 15.5003 13.3334V8.83337",
    stroke: "#667085",
    style: {
      stroke: "#667085",
      stroke: "color(display-p3 0.4009 0.4408 0.5207)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/SchoolIcon.55db8ca8865fdace68753b185c7b4994.svg";
export { ForwardRef as ReactComponent };